import { Box, styled } from '@mui/material';
import { useEffect, useState } from 'react';

export type BottomSheetProps = {
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
};

const StyledOverlay = styled(Box)(({ theme }) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
    zIndex: theme.zIndex.drawer + 1,
    opacity: 0,
    transition: 'opacity 300ms ease-in-out',
    '&.visible': {
        opacity: 1,
    },
}));

const StyledBottomSheet = styled(Box)(({ theme }) => ({
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.background.default,
    borderTopLeftRadius: theme.shape.borderRadius * 2,
    borderTopRightRadius: theme.shape.borderRadius * 2,
    padding: theme.spacing(2),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
    zIndex: theme.zIndex.drawer + 2,
    transform: 'translateY(100%)',
    transition: 'transform 300ms ease-in-out',
    maxHeight: '90vh',
    overflowY: 'auto',
    '&.visible': {
        transform: 'translateY(0)',
    },
}));

const BottomSheet = ({ open, onClose, children }: BottomSheetProps) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (open) {
            // Small delay to trigger animation
            setTimeout(() => setIsVisible(true), 10);
        } else {
            setIsVisible(false);
        }
    }, [open]);

    if (!open) return null;

    const handleOverlayClick = () => {
        setIsVisible(false);
        setTimeout(onClose, 300); // Wait for animation to complete
    };

    return (
        <>
            <StyledOverlay
                className={isVisible ? 'visible' : ''}
                onClick={handleOverlayClick}
            />
            <StyledBottomSheet
                className={isVisible ? 'visible' : ''}
                onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
            >
                {children}
            </StyledBottomSheet>
        </>
    );
};

export default BottomSheet;

